import React, { useRef, useEffect } from "react";
import { useSprings, animated } from "react-spring";
// import { useGesture } from "react-use-gesture";
// import { element } from "prop-types";
// import { Button } from "@material-ui/core";
// import { useHistory } from "react-router-dom";

const MyCarousel = (prop) => {
  const { globalState } = prop;
  // const history = useHistory();
  //   const pages = prop.sectionsData.map((item) => item.img);
  const pages = prop.sectionsData.map((item) => item);
  const activeTab = prop.activeTab;
  const beforeTab = prop.beforeTab;
  // const flag = prop.flag;
  const index = useRef(0);
  const [props, set] = useSprings(pages.length, (i) => ({
    x: i * window.innerWidth,
    sc: 1,
    display: "block",
    config: { mass: 4, tension: 230, friction: 40 },
  }));

  // const btnHandler = (i) => {
  //   if (i == 1) {
  //     window.location = "https://Shop.ghalichin.com/wiki";
  //     //   () => (window.location = "https://Shop.ghalichin.com/wiki");
  //   }
  //   if (i == 2) {
  //     history.push("/generator");
  //     //   () => history.push("/generator");
  //   }
  //   if (i == 3) {
  //     history.push("/room");
  //     //   () => history.push("/room");
  //   }
  //   if (i == 4) {
  //     window.location = "https://shop.ghalichin.com/";
  //   }
  //   if (i == 5) {
  //     history.push("/insurance");
  //     //   () => history.push("/insurance");
  //   }
  // };
  // const bind = useGesture(
  //   ({ down, delta: [xDelta], direction: [xDir], distance, cancel }) => {
  //     if (window.innerWidth < 550 || window.innerHeight >= 1900) {
  //       if (down && distance > window.innerWidth / 5)
  //         cancel(
  //           (index.current = clamp(
  //             index.current + (xDir > 0 ? -1 : 1),
  //             0,
  //             pages.length - 1
  //           ))
  //         );
  //       set((i) => {
  //         if (i < index.current - 1 || i > index.current + 1)
  //           return { display: "none" };
  //         const x =
  //           (i - index.current) * 2 * window.innerWidth + (down ? xDelta : 0);
  //         const sc = down ? 1 - distance / window.innerWidth / 2 : 1;
  //         return { x, sc, display: "block" };
  //       });
  //     }
  //   }
  // );

  // const bind = useGesture(
  //   ({ down, delta: [xDelta], direction: [xDir], distance, cancel }) => {
  //     if (down && distance > window.innerWidth / 5)
  //       cancel(
  //         (index.current = clamp(
  //           index.current + (xDir > 0 ? -1 : 1),
  //           0,
  //           pages.length - 1
  //         ))
  //       );
  //     set((i) => {
  //       if (i < index.current - 1 || i > index.current + 1)
  //         return { display: "none" };
  //       const x =
  //         (i - index.current) * 2 * window.innerWidth + (down ? xDelta : 0);
  //       const sc = down ? 1 - distance / window.innerWidth / 2 : 1;
  //       return { x, sc, display: "block" };
  //     });
  //   }
  // );

  const activeTabHandler = (activeTab, before) => {
    // console.log("log ", activeTab, before);
    index.current = activeTab;
    // clamp(
    //   index.current + (xDir > 0 ? -1 : 1),
    //   0,
    //   pages.length - 1
    // );
    set((activeTab) => {
      // const x =
      //   activeTab < index.current
      //     ? -(activeTab - index.current) * 2 * window.innerWidth
      //     : +(activeTab - index.current) * 2 * window.innerWidth;
      if (activeTab < index.current || activeTab > index.current)
        return {
          opacity: 0,
          display: "none",
          sc: 0.5,
          transform: "rotate(0deg) scale3d(1, 1, 1)",
          x: -(activeTab - index.current) * 2 * window.innerWidth,
        };
      // x = (activeTab - index.current) * 2 * window.innerWidth;
      // const x =
      //   index.current < activeTab
      //     ? -(activeTab - index.current) * 2 * window.innerWidth
      //     : +(activeTab - index.current) * 2 * window.innerWidth;
      // const x = -20;

      // + (down ? xDelta : 0);
      const sc =
        activeTab < index.current - 1 || activeTab > index.current + 1
          ? 1
          : 1 - 50 / window.innerWidth / 2;
      // const sc = 0.7;
      return {
        x: -(activeTab - index.current) * 2 * window.innerWidth,
        sc,
        display: "block",
        transform: "rotate(0deg)  scale3d(1, 1, 1)",
      };
    });
  };

  //   const otherAnimation = (i, before) => {
  //     if (i >= 1 && i >= before) {
  //       for (let n = 0; n < i - 1; n++) {
  //         let elemnet = document.getElementById(`animationItem${n}`);
  //         elemnet.style.transform = `translateX(-110%) rotate(${-10}deg) translateY(40px) `;
  //         elemnet.style.transition = "all 0.5s";
  //       }

  //       setTimeout(() => {
  //         document.getElementById(`animationItem${i - 1}`).style.transform =
  //           "translateX(0)";
  //         document.getElementById(`insideItem${i - 1}`).style.transform =
  //           "rotate(0deg)";
  //         document.getElementById(`animationItem${i - 1}`).style.display =
  //           "block";
  //         document.getElementById(`animationItem${i - 1}`).style.transition =
  //           "all 0.5s";
  //       }, i - 1 * 500 + 500);
  //     } else if (i >= 1 && i < before) {
  //       for (let n = before; n >= i; n--) {
  //         let elemnet = document.getElementById(`animationItem${n - 1}`);
  //         elemnet.style.transform = `translateX(110%) rotate(${10}deg) translateY(40px) `;
  //         elemnet.style.transition = "all 0.5s";
  //       }

  //       setTimeout(() => {
  //         document.getElementById(`animationItem${i - 1}`).style.transform =
  //           "translateX(0)";
  //         document.getElementById(`insideItem${i - 1}`).style.transform =
  //           "rotate(0deg)";
  //         document.getElementById(`animationItem${i - 1}`).style.display =
  //           "block";
  //         document.getElementById(`animationItem${i - 1}`).style.transition =
  //           "all 0.5s";
  //       }, i - 1 * 500 + 500);
  //     }
  //   };

  // const otherAnimation = (i, before) => {
  //   if (i > before) {
  //     //   if (i == 0) {
  //     //     let elemnet = document.getElementById(`animationItem${0}`);
  //     //     elemnet.style.transform = `translateX(-110%) rotate(${-10}deg) translateY(40px) `;
  //     //     elemnet.style.transition = "all 0.5s";
  //     //   }

  //     for (let n = 0; n < i; n++) {
  //       // let elemnet = document.getElementsByClassName(`animationItem${n}`);
  //       // // console.log("log elemnetssss", elemnet[1]);
  //       // // debugger;
  //       let elemnet = document.getElementById(`animationItem${n}`);

  //       console.log("log element", i, before);
  //       elemnet.style.transform = `translateX(-110%) rotate(${-10}deg) translateY(40px) `;
  //       elemnet.style.transition = "all 1s ";
  //     }

  //     setTimeout(() => {
  //       document.getElementById(`animationItem${i}`).style.transform =
  //         "translateX(0)";
  //       document.getElementById(`insideItem${i}`).style.transform =
  //         "rotate(0deg) ";
  //       document.getElementById(`animationItem${i}`).style.display = "block ";
  //       document.getElementById(`animationItem${i}`).style.transition =
  //         "all 1s";
  //     }, i - 1 * 500 + 500);

  //     //   setTimeout(() => {
  //     //     let element2 = (document.getElementsByClassName(
  //     //       `animationItem${i}`
  //     //     ).style.transform = "translateX(0)");
  //     //     let element3 = document.getElementsByClassName(`insideItem${i}`).style
  //     //       .transform;

  //     //     if (element2?.length > 0) {
  //     //       element2 = element2[1];
  //     //     }
  //     //     if (element3?.length > 0) {
  //     //       element3 = element3[1];
  //     //     }

  //     //     element2.style.transform = "translateX(0)";
  //     //     element3.style.transform = "rotate(0deg) ";
  //     //     element2.style.display = "block ";
  //     //     element2.style.transition = "all 1s";

  //     // }, i - 1 * 500 + 500);
  //   } else if (i < before) {
  //     for (let n = before; n > i; n--) {
  //       let elemnet = document.getElementById(`animationItem${n}`);
  //       elemnet.style.transform = `translateX(110%) rotate(${10}deg) translateY(40px) `;
  //       elemnet.style.transition = "all 1s";
  //     }

  //     setTimeout(
  //       () => {
  //         document.getElementById(`animationItem${i}`).style.transform =
  //           "translateX(0)";
  //         document.getElementById(`insideItem${i}`).style.transform =
  //           "rotate(0deg)";
  //         document.getElementById(`animationItem${i}`).style.display = "block";
  //         document.getElementById(`animationItem${i}`).style.transition =
  //           "all 1s";
  //       },
  //       i - 1 * 500
  //       // i - 1 >= 0 ? i - 1 : 0 * 500 + 500
  //     );
  //   }
  // };

  useEffect(() => {
    activeTabHandler(activeTab, beforeTab);
    // otherAnimation(activeTab, beforeTab);
  }, [activeTab]);

  return props.map(({ x, display, sc }, i) => (
    <animated.div
      // {...bind()}
      id={`animationItem${i}`}
      //   className={`animationItem${i}`}
      key={i}
      style={{
        display,
        // flex: 1,

        transform: x.interpolate(
          (x) => `translate3d(${x / 2}px,0,0) 
        rotate(${index.current === i ? 0 : i === index.current - 1 ? 0 : 0}deg)
      
       
        `
        ),
      }}
    >
      <animated.div
        id={`insideItem${i}`}
        // className={`insideItem${i}`}
        // className={flag?''}
        style={{
          //   border: "12px solid",
          // opacity: i == index.current - 1 ? 1 : 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          //   flex: 1,
          height: "100%",
          //   flex: 1.5,
          // opacity: index.current == i ? 1 : i == index.current + 1 ? 0.2 : 0.2,
          // transition: "opacity 0.3s",
          transform: sc.interpolate(
            (s) =>
              `scale(${s}) rotate(${
                index.current === i ? 0 : i === index.current - 1 ? 0 : 0
              }deg) translateY(${i === index.current ? 0 : 0}px) `
          ),
          //   backgroundImage: "url(" + `${pages[i].img}` + ")",
          // backgroundImage:
          //   i == 0
          //     ? "url(" + `${pages[0].img}` + ")"
          //     : "url(" +
          //       `${pages[i].gif}` +
          //       "),url('./static/svg/rectangle.svg')",
          backgroundImage:
            i === 0
              ? "url(" + `${pages[0].img}` + ")"
              : " url('./static/svg/rectangle.svg'), url('./static/svg/rectangle-shadow.svg')",

          backgroundSize: i === 0 ? "contain" : "contain ,contain",

          // backgroundPosition: "center",
          backgroundPositionX:
            i === 0
              ? globalState.themeDirection === "ltr"
                ? "left"
                : "right"
              : "left, left",
          // backgroundPositionY: i == 0 ? "center" : "0% ,20%",
          backgroundRepeat: i === 0 ? "no-repeat" : "no-repeat, no-repeat",
          // backgroundPosition: "center",
          // backgroundSize:
          //   i == 0
          //     ? "contain"
          //     : i == 4
          //     ? "contain"
          //     : i == 3
          //     ? "90% 110% , contain"
          //     : i == 5
          //     ? "contain"
          //     : "cover, contain",
          // backgroundPosition:
          //   i == 0 ? "center center" : "bottom center,  center",
          // backgroundSize: " contain",
          // backgroundPosition: "center center",
        }}
      >
        {/* <img src={pages[i].gif}></img> */}
        {i > 0 && (
          <div
            className="landingGifContainer"
            style={{
              backgroundImage: "url(" + `${pages[i].gif}` + ")",
              backgroundSize:
                i === 1 || i === 2 || i === 3 ? "100%" : "contain",
              backgroundPositionX: "center",
              backgroundPositionY:
                i === 1 || i === 2 ? "bottom" : i === 3 ? "65%" : "center",
              // backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              // alignSelf: "flex-end",
            }}
          ></div>
        )}
      </animated.div>
    </animated.div>
  ));
};

export default MyCarousel;
